/**
 * Marka je stablo iz originalnog logotipa, prebojeno u paletu (`packages/brand`).
 * Slika je u `public/brand/`, ne u bundleu — logotip se ne mijenja s kodom.
 */
export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <span className="inline-flex select-none items-center gap-2.5">
      <img
        src="/brand/logo-mark-light-128.png"
        alt=""
        aria-hidden="true"
        width={compact ? 28 : 36}
        height={compact ? 28 : 36}
        className={compact ? 'h-7 w-7 shrink-0' : 'h-9 w-9 shrink-0'}
      />
      <span className="flex flex-col leading-none">
        <span className="font-display text-[22px] font-semibold tracking-[2px] text-ink">
          SOUL<span className="text-accent">.</span>
        </span>
        {!compact && (
          <span className="font-body text-[9px] uppercase tracking-[3px] text-ink-muted">Training</span>
        )}
      </span>
    </span>
  );
}
